/**
 * Type utility functions for handling null/undefined conversions
 * These help maintain backwards compatibility while fixing TypeScript errors
 */

/**
 * Convert null to undefined
 */
export const nullToUndefined = <T>(value: T | null): T | undefined => {
  return value === null ? undefined : value;
};

/**
 * Convert undefined to null
 */
export const undefinedToNull = <T>(value: T | undefined): T | null => {
  return value === undefined ? null : value;
};

/**
 * Ensure a value is a string, providing a default if null/undefined
 */
export const ensureString = (value: string | null | undefined, defaultValue = ""): string => {
  return value ?? defaultValue;
};

/**
 * Handle optional parameters that can be either null or undefined
 * and convert to the expected type
 */
export const normalizeOptional = <T>(value: T | null | undefined): T | null | undefined => {
  return value;
};

/**
 * Convert null/undefined to empty string for API calls
 */
export const toApiString = (value: string | null | undefined): string => {
  return value || "";
};

/**
 * Safe access token handler - accepts both null and undefined
 * Returns the value as-is for maximum compatibility
 */
export const normalizeAccessToken = (token: string | null | undefined): string | null => {
  return token === undefined ? null : token;
};
